import React, {Component } from 'react';
import { Breadcrumb, Card,Table, DatePicker,Button,Tooltip,Modal,Form,Input, Upload,Select,Spin,Divider,InputNumber,Menu, Dropdown     } from 'antd';
import { WalletOutlined,SendOutlined,EditOutlined,DeleteOutlined,CloudUploadOutlined, UploadOutlined,DownOutlined,ExclamationCircleOutlined,WarningOutlined, DoubleRightOutlined} from '@ant-design/icons';
import {Row, Col} from 'react-bootstrap';
import mHelper from './../../config/Helper';
import mNotaControllers from './../../control/nota/index.controller';
import moment from 'moment';
import reqwest from 'reqwest';
import HeaderTitle from '../../component/HeaderTitle/HeaderTitle'
var isLogin = JSON.parse(mHelper.GET_COOKIES('login_portal'));

const layout = {
    labelCol: {
      span: 10,
    },
    wrapperCol: {
      span: 14,
    },
};

const layoutPendukung = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 19,
    },
};



var thisComponent;
var formUploadNotaDebet = React.createRef();
const { Option } = Select;
const { TextArea } = Input;
const { confirm } = Modal;
class UploadNotaDebet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            AdCode : isLogin.company.ad_code,
            AdName : isLogin.company.ad_name,
            TableUploadNotaDebet  : [],
            Periode: mHelper.GET_DATE_DIGIPOS(),
            PeriodeNota : mHelper.GET_DATE_DIGIPOS(),
            modalFormUploadNotaDebet : false,
            qty_nota : 0,
            price_nota:0,
            fileBukpot : [],
            fileBukBayar : [],
            fileNotaDebet : [],
            fileBARRecon : [],
            fileSummary : [],
            loadingUploadNotaDebet : false,
            typeTrx : 2,
            NotaSelected : "",
            UploadBukPotProgress : 0,
            UploadBukBayarProgress : 0,
            UploadNotaProgress : 0,
            UploadBarProgress : 0,
            data_price : {qty_trx : 1 ,price : 0 , pph_amount :0 , total_amount : 0},
            formHide : false,
        };
        thisComponent = this;
    }

    async componentDidMount() {
        this.onRefreshDataNotaDebet();
        this.onGetDataDigipos(this.state.PeriodeNota,this.state.AdCode);
        this.onHideCondition();
    }
    
    onGetDataDigipos = (periode , ad_code) => {
        var FilterData = {where : { and :  [{trx_date_group: periode},{ ad_code:ad_code}] }}
        // this.setState({loadingUploadInvoice : true});
        mNotaControllers.GET_DATA_DIGIPOS(FilterData,(r)=>{
            // console.log(r);
            for(var i in r){
                var rawDataDigipos = r[i];
                this.setState({data_price  :{qty_trx : 1 ,price : rawDataDigipos.pph_paid_amount , pph_amount :rawDataDigipos.vat_paid_amount , total_amount :rawDataDigipos.pph_paid_amount}})
            }
            
            if(r.length == 0){
                this.setState({data_price  :{qty_trx : 1 ,price : 0 , pph_amount :0 , total_amount :0}})
            }
            // this.setState({loadingUploadInvoice : false});
            if(this.state.NotaSelected != ""){
                thisComponent.onUpdateDataNota({
                    qty_trx : thisComponent.state.data_price.qty_trx ,
                    price : thisComponent.state.data_price.price , 
                    pph_amount :thisComponent.state.data_price.pph_amount , 
                    total_amount :thisComponent.state.data_price.total_amount
                });
                formUploadNotaDebet.current.setFieldsValue({ 
                    qty_trx :thisComponent.state.data_price.qty_trx,
                    price : thisComponent.state.data_price.price,
                    total_amount : thisComponent.state.data_price.total_amount,
                });
            }
        });
    }
    
    onRefreshDataNotaDebet = () => {
        this.setState({loadingUploadNotaDebet: true});
        this.state.loadingUploadNotaDebet = true;
        var filter = {where: { and: [ {periode : this.state.Periode}, {type_trx : this.state.typeTrx },{ad_code : this.state.AdCode}] } };
        mNotaControllers.GET_DATA_NOTA(filter,(r)=>{
            var datas = [];
            for(var  i in r){
                var infoRaw = r[i];
                var status = ["Draft","Waiting Validate...","Waiting Approval...","Proses  by Treasury...","Finish","Reject","Waiting Payment..." ];
                var FileAttach = [];
                var barStore = infoRaw.bar_attachment == null ? [] : infoRaw.bar_attachment.split(";");
                for(var iBAR in barStore){
                    FileAttach.push({title : "DOC BAR RECON #"+(parseInt(iBAR)+1) ,  fileName : barStore[iBAR]});
                }
                if(infoRaw.inv_attahment !== null){ FileAttach.push({title : "DOC NOTA DEBIT" ,  fileName : infoRaw.inv_attahment}); }
                if(infoRaw.wht_attachment !== null){ FileAttach.push({title : "DOC BUKTI POTONG" ,  fileName : infoRaw.wht_attachment}); }
                if(infoRaw.bb_attachment !== null){ FileAttach.push({title : "DOC BUKTI BAYAR" ,  fileName : infoRaw.bb_attachment}); }
                if(infoRaw.summary_attachment !== null){ FileAttach.push({title : "DOC SUMMARY" ,  fileName : infoRaw.summary_attachment}); }
                datas.push({
                    key:infoRaw.id,
                    action : infoRaw.id,
                    periode_trx : infoRaw.periode,
                    ad_code : infoRaw.ad_code,
                    ad_name:infoRaw.ad_name,
                    inv_number :infoRaw.inv_number,
                    description : infoRaw.description,
                    inv_qty : infoRaw.qty_trx,
                    price : mHelper.GENERATE_PULUHAN(infoRaw.price == null ? 0 : infoRaw.price),
                    total_amount : mHelper.GENERATE_PULUHAN(infoRaw.total_amount == null ? 0 : infoRaw.total_amount ),
                    remarks : infoRaw.remarks,
                    file : {
                        key : i,
                        info :FileAttach
                    },
                    status:infoRaw.fpjp_hold_state == 1 &&  infoRaw.state == 3 ? "Review AP..." : status[infoRaw.state]  ,
                    state : infoRaw.state,
                    note : {hold_state : infoRaw.fpjp_hold_state , note_state : infoRaw.fpjp_note_state,desc : infoRaw.fpjp_note} 
                });
            }
            // this.state.TableUploadNotaDebet = datas;
            // this.state.loadingUploadNotaDebet = false;
            this.setState({TableUploadNotaDebet : datas, loadingUploadNotaDebet: false});
        });
    }

    onUploadNotaDebet = () => {
        this.setState({loadingUploadNotaDebet:true});
        this.onHideCondition();
        mNotaControllers.ADD_NOTA_DRAFT(
            this.state.PeriodeNota,
            this.state.AdCode == null ? "-" : this.state.AdCode,
            this.state.AdName == null ? "-" : this.state.AdName,
            this.state.typeTrx,
            mHelper.CURRENT_TIME_MILIS().toString(),
            isLogin.id,(r)=>{
                if(r.success == true){
                    this.setState({modalFormUploadNotaDebet:true});
                    setTimeout(()=>{
                        formUploadNotaDebet.current.resetFields();
                        this.setState({ loadingUploadNotaDebet:false, NotaSelected : r.data.id, fileBARRecon:[], fileBukpot : [], fileBukBayar : [], fileNotaDebet : [], fileSummary : []});
                        formUploadNotaDebet.current.setFieldsValue({ 
                            ad_code: this.state.AdCode,
                            ad_name:this.state.AdName,
                            periode : this.state.PeriodeNota ,
                            type_trx : this.state.typeTrx
                        });
                        this.onGetDataDigipos( this.state.PeriodeNota,this.state.AdCode);
                    },2000);
                }else{
                    Modal.info({
                        title: 'Error',
                        content: (
                          <div>
                            <p>{r.message}</p>
                          </div>
                        ),
                        onOk() {},
                    });
                    this.setState({loadingUploadNotaDebet:false,modalFormUploadNotaDebet:false});
                }
        });

    }

    onHideCondition = () =>{
        var today = new Date(this.state.PeriodeNota+"-"+"01");
        var MonthNow  = (today.getMonth() + 1);
        var YearNow   = today.getFullYear();
        if(parseInt(MonthNow) >= 8 && parseInt(MonthNow) <= 12 && parseInt(YearNow) == 2021){
            this.setState({formHide:true});
        }else{
            this.setState({formHide:false});
        }
    }

    onChangeDate = (date, dateString) => {
        this.onHideCondition();
        this.setState({Periode:dateString,PeriodeNota : dateString});
    }

    
    onChangeDateInv = (date, dateString)=> {
        this.onUpdateDataNota({inv_date : dateString});
    }

    onCancelFormUploadNotaDebet = () => {
        this.onRefreshDataNotaDebet();
        this.setState({modalFormUploadNotaDebet:false});
    }

    onSubmitNota = (row) => {

        var today = new Date(this.state.PeriodeNota+"-"+"01");
        var MonthNow  = (today.getMonth() + 1);
        var YearNow   = today.getFullYear();
        var SkipFile = false;
        if(parseInt(MonthNow) >= 8 && parseInt(MonthNow) <= 12 && parseInt(YearNow) == 2021){
            SkipFile = true;
        }

        if(this.state.fileBARRecon.length === 0){
            Modal.info({
                title: 'Error',
                content: (
                  <div>
                    <p>File Document BAR Recon harus di upload tidak boleh kosong  !</p>
                  </div>
                ),
                onOk() {},
            });
            return;
        }
        if(this.state.fileNotaDebet.length === 0 && SkipFile === false){
            Modal.info({
                title: 'Error',
                content: (
                  <div>
                    <p>File Document Nota Debet harus di upload tidak boleh kosong !</p>
                  </div>
                ),
                onOk() {},
            });
            return;
        }
        if(this.state.fileBukpot.length === 0  && SkipFile === false){
            Modal.info({
                title: 'Error',
                content: (
                  <div>
                    <p>File Document Bukti Potong harus di upload tidak boleh kosong !</p>
                  </div>
                ),
                onOk() {},
            });
            return;
        }
        if(this.state.fileBukBayar.length === 0  && SkipFile === false){
            Modal.info({
                title: 'Error',
                content: (
                  <div>
                    <p>File Document Bukti Bayar harus di upload tidak boleh kosong !</p>
                  </div>
                ),
                onOk() {},
            });
            return;
        }
        if(this.state.fileSummary.length === 0){
            Modal.info({
                title: 'Error',
                content: (
                  <div>
                    <p>File Document Summary harus di upload tidak boleh kosong !</p>
                  </div>
                ),
                onOk() {},
            });
            return;
        }

        if(SkipFile === false){
            if(row.pph_number == null || row.pph_number == ""){
                Modal.info({
                    title: 'Error',
                    content: (
                    <div>
                        <p>Number Nota Debit tidak boleh kosong !</p>
                    </div>
                    ),
                    onOk() {},
                });
                return;
            }
        }

        mNotaControllers.SUBMIT_NOTA(this.state.NotaSelected,(r)=>{
            if(r.success == true){
                formUploadNotaDebet.current.resetFields();
                this.onRefreshDataNotaDebet();
                this.setState({modalFormUploadNotaDebet:false,fileBARRecon :[], fileBukpot : [], fileBukBayar : [], fileNotaDebet : []});
                mHelper.ON_SEND_MESSAGE_NOTIF({
                    types: "NOTIFICATION",
                    target: "1,4,5",
                    to: "",
                    from_who: this.state.AdCode,
                    subject: "Data FPJP Nota Debit telah disubmit oleh AD",
                    body: "Document FPJP Nota Debit berhasil di submit oleh : "+ this.state.AdName,
                    path_url: "",
                    app: "DIGIPOS",
                    code: "15010101",
                    code_label: "",
                    at_create: mHelper.CURRENT_TIME_MILIS(),
                    at_read: "",
                    periode:  this.state.PeriodeNota,
                    at_flag: 0
                });
            }else{
                Modal.info({
                    title: 'Error',
                    content: (r.message == undefined ? JSON.stringify(r) : r.message ),
                    onOk() {},
                });
            }
        });
    }
    
    onFinishFormUploadNotaDebet= (row) => {
        confirm({
            title: 'Submit Invoice',
            icon: <ExclamationCircleOutlined />,
            content: 'Kamu yakin ingin sumbmit data nota debit ini ? ( * nota debit yang sudah disumbmit tidak akan bisa di edit / dihapus )',
            onOk() {
               thisComponent.onSubmitNota(row);
            },
            onCancel() {
            },
        });
    }

    onChangeQtyNotaDebet = (values) => {
        var Qty = values == "" || values == null ? 0 : values;
        this.setState({qty_nota : Qty});
        var PriceTotal = parseFloat(Qty) * parseFloat(this.state.price_nota);
        var Total = PriceTotal;
        formUploadNotaDebet.current.setFieldsValue({ 
            total_amount : Total,
            qty_trx:Qty
        });
        this.onUpdateDataNota({"qty_trx":Qty, total_amount : Total , pph_amount : 0});
    }

    onChangePriceNotaDebet= (values) => {
        var Price = values == "" || values == null ? 0 : values;
        this.setState({price_nota : Price});
        var PriceTotal = parseFloat(Price) * parseFloat(this.state.qty_nota);
        var Total  = PriceTotal;
        formUploadNotaDebet.current.setFieldsValue({ 
            total_amount :Total,
            qty_trx:this.state.qty_nota
        });
        this.onUpdateDataNota({"price":Price, total_amount : Total , pph_amount : 0});
    }
    
    onProcessNota = () => {
        this.setState({qty_nota : 0 , price_nota :  0});
        this.onRefreshDataNotaDebet();
    }

    
    handelUpdateNota = (id) => {
        this.setState({loadingUploadNotaDebet:true});
        this.onHideCondition();

        mNotaControllers.GET_SELECT_NOTA(id,(r)=>{
            if(r.state != 0 && r.state !== 5 && r.fpjp_hold_state !=1 ){
                this.setState({loadingUploadNotaDebet:false});
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>Tidak bisa merubah  nota debit kecuali status nota debit draft / reject !</p>
                      </div>
                    ),
                    onOk() {},
                });
                return;
            }
            this.setState({modalFormUploadNotaDebet:true,NotaSelected : id,fileBARRecon:[], fileBukpot : [], fileBukBayar : [], fileNotaDebet : []});
            setTimeout(()=>{
                formUploadNotaDebet.current.resetFields();
                var bar = r.bar_attachment === null || r.bar_attachment === "" ? []:r.bar_attachment.split(";");
                var flielBAR = [];
                for(var iBAR in bar){
                    var infoBar = bar[iBAR];
                    flielBAR.push({uid: id + "_" + (infoBar + 1), name: infoBar, status: 'done'});
                }
                var fileNotaDebet = r.inv_attahment === "" || r.inv_attahment === null ? [] : [{uid: id , name: r.inv_attahment, status: 'done'}];
                var fileBukpot = r.wht_attachment === "" || r.wht_attachment === null ? [] : [{uid: id , name: r.wht_attachment, status: 'done'}];
                var fileBukbar = r.bb_attachment === "" || r.bb_attachment === null ? [] : [{uid: id , name: r.bb_attachment, status: 'done'}];
                var fileSm = r.summary_attachment === "" || r.summary_attachment === null ? [] : [{uid: id , name: r.summary_attachment, status: 'done'}];
                this.setState({fileBARRecon : flielBAR, fileNotaDebet : fileNotaDebet, fileBukpot : fileBukpot, fileBukBayar : fileBukbar, fileSummary : fileSm});
                formUploadNotaDebet.current.setFieldsValue({ 
                    ad_code: this.state.AdCode,
                    ad_name:this.state.AdName,
                    periode : r.periode ,
                    pph_number : r.inv_number,
                    fp_number : r.fp_number,
                    description : r.description,
                    qty_trx : r.qty_trx,
                    price : r.price,
                    total_amount : r.total_amount,
                    remarks : r.remarks,
                    inv_date :moment(r.inv_date, "YYYY-MM-DD")
                });
                this.setState({loadingUploadNotaDebet:false,qty_nota : r.price , price_nota :  r.price});
            },2000);
        });
    }

    onUpdateDataNota = (raw) => {
        var info = {};
        // console.log(raw);
        info["periode"] = this.state.PeriodeNota;
        info["ad_code"] = this.state.AdCode;
        info["ad_name"] = this.state.AdName;
        info["type_trx"] = this.state.typeTrx;
        info["at_create"] = mHelper.CURRENT_TIME_MILIS().toString();
        info["by_create"] = isLogin.id;
        // info[key] = values;
        for(var i in raw){
            info[i] = raw[i];
        }
        mNotaControllers.UPDATE_NOTA_DATA(this.state.NotaSelected,info,(r)=>{
            // console.log(r);
        });
    }

    handleOpenFile = (e,info) => {
        // console.log(e.key,key);
        // console.log(e.key,info);
        var FileInfo = info[e.key];
        var folder = "bar_recon";
        switch(FileInfo.title){
            case "DOC BAR RECON #1" :
                folder ="bar_recon";
            case "DOC BAR RECON #2" :
                folder ="bar_recon";
                break;
            case "DOC NOTA DEBIT" :
                folder ="nota";
                break;
            case "DOC BUKTI POTONG" :
                folder ="bukpot";
                break;
            case "DOC BUKTI BAYAR" :
                folder ="bukti_bayar";
                break;
            case "DOC SUMMARY" :
                folder ="summary";
                break;
            default :
                folder ="bar_recon";
                break;
        }

        mNotaControllers.GET_FILE_DOC({folder :folder,names:FileInfo.fileName },(r)=>{
            if(r.success == true){
                const buff = Buffer.from(r.data, "base64");
                const file = new Blob([buff],{type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }else{
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>File tidak bisa ditemukan !</p>
                      </div>
                    ),
                    onOk() {},
                });
            }
        });
    }   


    //UPLOAD NOTA DEBIT
    handleUploadNotaDebitChange = info => {
        let fileList = [...info.fileList];
        this.setState({ fileNotaDebet: fileList });
    }

    removeNotaDebit= file =>{
        // console.log(file);
        mNotaControllers.DELETE_FILE_NOTA(parseInt(file.uid),"nota-debit",file.name,(r)=>{
            // console.log(r);
        });
        this.setState(state => {
            const index = state.fileNotaDebet.indexOf(file);
            const newFileList = state.fileNotaDebet.slice();
            newFileList.splice(index, 1);
            return {
                fileNotaDebet: newFileList,
            };
        });
    }

    uploadNotaDebit = async options => {
        const { onSuccess, onError, file, onProgress } = options;
        const formData = new FormData();
        const config = {
          headers: { "content-type": "multipart/form-data" },
          onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            this.setState({UploadNotaProgress:percent})
            if (percent === 100) {
              setTimeout(() => {
                this.setState({UploadNotaProgress:0});
              }, 1000);
            }   
            onProgress({ percent: (event.loaded / event.total) * 100 });
          }
        };
        formData.append("id", this.state.NotaSelected);
        formData.append("periode", this.state.PeriodeNota);
        formData.append("ad_code", this.state.AdCode);
        formData.append("ad_name", this.state.AdName);
        formData.append("doc_nota", file);
        reqwest({
            url: mHelper.URL_API() + "/nota-debit/upload_nota",
            method: 'post',
            headers: {
                "Authorization": "Bearer " + isLogin.token
            },
            processData: false,
            data: formData,
            success: (r) => {
                onSuccess("Ok");
                this.setState({fileNotaDebet:[r.data]});
            },
            error: (err) => {
                onError({ err });
            },
        });
    }

    // UPLOAD SUMMARY
    handleUploadSummaryChange = info => {
        let fileList = [...info.fileList];
        this.setState({ fileSummary: fileList });
    }

    removeSummary= file =>{
        // console.log(file);
        mNotaControllers.DELETE_FILE_NOTA(parseInt(file.uid),"summary",file.name,(r)=>{
            // console.log(r);
        });
        this.setState(state => {
            const index = state.fileSummary.indexOf(file);
            const newFileList = state.fileSummary.slice();
            newFileList.splice(index, 1);
            return {
                fileSummary: newFileList,
            };
        });
    }

    uploadSummary = async options => {
        const { onSuccess, onError, file, onProgress } = options;
        const formData = new FormData();
        const config = {
          headers: { "content-type": "multipart/form-data" },
          onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            this.setState({UploadNotaProgress:percent})
            if (percent === 100) {
              setTimeout(() => {
                this.setState({UploadNotaProgress:0});
              }, 1000);
            }   
            onProgress({ percent: (event.loaded / event.total) * 100 });
          }
        };
        formData.append("id", this.state.NotaSelected);
        formData.append("periode", this.state.PeriodeNota);
        formData.append("ad_code", this.state.AdCode);
        formData.append("ad_name", this.state.AdName);
        formData.append("doc_summary", file);
        reqwest({
            url: mHelper.URL_API() + "/nota-debit/upload_summary",
            method: 'post',
            headers: {
                "Authorization": "Bearer " + isLogin.token
            },
            processData: false,
            data: formData,
            success: (r) => {
                onSuccess("Ok");
                this.setState({fileSummary:[r.data]});
            },
            error: (err) => {
                onError({ err });
            },
        });
    }

    //UPLOAD BUKTI POTONG
    handleUploadBukpotChange = info => {
        let fileList = [...info.fileList];
        this.setState({ fileBukpot: fileList });
    }

    removeBukpot= file =>{
        // console.log(file);
        mNotaControllers.DELETE_FILE_NOTA(parseInt(file.uid),"bukpot",file.name,(r)=>{
            // console.log(r);
        });
        this.setState(state => {
            const index = state.fileNotaDebet.indexOf(file);
            const newFileList = state.fileNotaDebet.slice();
            newFileList.splice(index, 1);
            return {
                fileNotaDebet: newFileList,
            };
        });
    }

    uploadBukpot= async options => {
        const { onSuccess, onError, file, onProgress } = options;
        const formData = new FormData();
        const config = {
          headers: { "content-type": "multipart/form-data" },
          onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            this.setState({UploadNotaProgress:percent})
            if (percent === 100) {
              setTimeout(() => {
                this.setState({UploadNotaProgress:0});
              }, 1000);
            }
            onProgress({ percent: (event.loaded / event.total) * 100 });
          }
        };
        formData.append("id", this.state.NotaSelected);
        formData.append("periode", this.state.PeriodeNota);
        formData.append("ad_code", this.state.AdCode);
        formData.append("ad_name", this.state.AdName);
        formData.append("doc_bukpot", file);
        reqwest({
            url: mHelper.URL_API() + "/nota-debit/upload_bukpot",
            method: 'post',
            headers: {
                "Authorization": "Bearer " + isLogin.token
            },
            processData: false,
            data: formData,
            success: (r) => {
                onSuccess("Ok");
                this.setState({fileBukpot:[r.data]});
            },
            error: (err) => {
                onError({ err });
            },
        });
    }

    //UPLOAD BUKTI BAYAR
    handleUploadBukbayarChange = info => {
        let fileList = [...info.fileList];
        this.setState({ fileBukBayar: fileList });
    }

    removeBukbayar= file =>{
        // console.log(file);
        mNotaControllers.DELETE_FILE_NOTA(parseInt(file.uid),"bukti-bayar",file.name,(r)=>{
            // console.log(r);
        });
        this.setState(state => {
            const index = state.fileBukBayar.indexOf(file);
            const newFileList = state.fileBukBayar.slice();
            newFileList.splice(index, 1);
            return {
                fileBukBayar: newFileList,
            };
        });
    }

    uploadBukbayar= async options => {
        const { onSuccess, onError, file, onProgress } = options;
        const formData = new FormData();
        const config = {
          headers: { "content-type": "multipart/form-data" },
          onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            this.setState({UploadNotaProgress:percent})
            if (percent === 100) {
              setTimeout(() => {
                this.setState({UploadNotaProgress:0});
              }, 1000);
            }
            onProgress({ percent: (event.loaded / event.total) * 100 });
          }
        };
        formData.append("id", this.state.NotaSelected);
        formData.append("periode", this.state.PeriodeNota);
        formData.append("ad_code", this.state.AdCode);
        formData.append("ad_name", this.state.AdName);
        formData.append("doc_buktibayar", file);
        reqwest({
            url: mHelper.URL_API() + "/nota-debit/upload_buktibayar",
            method: 'post',
            headers: {
                "Authorization": "Bearer " + isLogin.token
            },
            processData: false,
            data: formData,
            success: (r) => {
                onSuccess("Ok");
                this.setState({fileBukBayar:[r.data]});
            },
            error: (err) => {
                onError({ err });
            },
        });
    }

    //UPLOAD BAR
    handleUploadBarChange = info => {
        let fileList = [...info.fileList];
        this.setState({ fileBARRecon: fileList });
    }

    removeBar = file =>{
        // console.log(file);
        var id = file.uid.toString().split("_");
        mNotaControllers.DELETE_FILE_NOTA(parseInt(id[0]),"bar",file.name,(r)=>{
            // console.log(r);
        });
        this.setState(state => {
            const index = state.fileBARRecon.indexOf(file);
            const newFileList = state.fileBARRecon.slice();
            newFileList.splice(index, 1);
            return {
                fileBARRecon: newFileList,
            };
        });
    }
    
    uploadBar = async options => {

        const { onSuccess, onError, file, onProgress } = options;
        const formData = new FormData();
        const config = {
          headers: { "content-type": "multipart/form-data" },
          onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            this.setState({UploadInvProgress:percent})
            if (percent === 100) {
              setTimeout(() => {
                this.setState({UploadInvProgress:0});
              }, 1000);
            }
            onProgress({ percent: (event.loaded / event.total) * 100 });
          }
        };
        formData.append("id", this.state.NotaSelected);
        formData.append("periode", this.state.PeriodeNota);
        formData.append("ad_code", this.state.AdCode);
        formData.append("ad_name", this.state.AdName);
        formData.append("bar_recon", file);
        reqwest({
            url: mHelper.URL_API() + "/nota-debit/upload_bar_recon",
            method: 'post',
            headers: {
                "Authorization": "Bearer " + isLogin.token
            },
            processData: false,
            data: formData,
            success: (r) => {
                onSuccess("Ok");
                this.setState({fileBARRecon:r.data});
                if(r.success === false){
                    Modal.info({
                        title: 'Error',
                        content: (
                          <div>
                            <p>{r.message}</p>
                          </div>
                        ),
                        onOk() {},
                    });
                }
            },
            error: (err) => {
                onError({ err });
                // callback({success:false, data:[], message : "add paid invoice  error"});
            },
        });
    }

    handleDeleteNota = (id) => {
        mNotaControllers.GET_SELECT_NOTA(id,(r)=>{
            if(r.state != 0 ){
                this.setState({loadingUploadNotaDebet:false});
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>Tidak bisa menghapus  nota debit kecuali status nota debit draft !</p>
                      </div>
                    ),
                    onOk() {},
                });
                return;
            }
            confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined />,
                content: 'Kamu yakin ingin menghapus data ini ?',
                onOk() {
                    mNotaControllers.DELETE_NOTA(id,(r)=>{
                        thisComponent.onRefreshDataNotaDebet();
                    })
                },
                onCancel() {
                },
            });
        });
    }

    columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: text => {
                return(
                    <div>
                        <Tooltip placement="bottom" title={"Edit Invoice Upload"}>
                            <Button type="primary" className="btn-tools btn-info" size="small" icon={<EditOutlined /> } onClick={(e)=> {this.handelUpdateNota(text)}}></Button>
                        </Tooltip>
                        <Tooltip placement="bottom" title={"Delete Invoice Upload"}>
                            <Button className="btn-tools" type="danger" size="small" icon={<DeleteOutlined /> }  onClick={(e)=> {this.handleDeleteNota(text)}}></Button>
                        </Tooltip>
                    </div>
                )
            }
        },
        {
            title: 'Periode',
            dataIndex: 'periode_trx',
            key: 'periode_trx',
            render: text => <span>{text}</span>,
        },
        {
          title: 'Kode AD',
          dataIndex: 'ad_code',
          key: 'ad_code',
          render: text => <span>{text}</span>,
        },
        {
          title: 'Nama AD',
          dataIndex: 'ad_name',
          key: 'ad_name',
        },
        {
          title: 'Nomor PPH ',
          dataIndex: 'inv_number',
          key: 'inv_number',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Invoice Qty',
            dataIndex: 'inv_qty',
            key: 'inv_qty',
        },
        
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
        },
        {
            title: 'Total Amount',
            dataIndex: 'total_amount',
            key: 'total_amount',
        },
        {
            title: 'Remarks',
            dataIndex: 'remarks',
            key: 'remarks',
        },
        {
            title: 'File',
            dataIndex: 'file',
            key: 'file',
            render: text => {
                const menu = (
                    <Menu onClick={(e)=>this.handleOpenFile(e,text.info)}>
                        {
                            Object.keys(text.info).map(label =>(
                                <Menu.Item key={label}>
                                    <span>{text.info[label].title}</span>
                                </Menu.Item>
                            )
                        )}
                    </Menu>
                );
                return(
                    <Dropdown overlay={menu} trigger={['click']}>
                       <Button className="primaryButton" size="small" >Open <DownOutlined /></Button> 
                    </Dropdown>
                )
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Note',
            dataIndex: 'note',
            key: 'note',
            render: text => {
                if(text.hold_state == 1 && text.note_state === 1){
                    return(
                        <Tooltip placement="top" title={text.desc}>
                            <Button  className="btn-tools btn-error" size="small" style={{backgroundColor:"#FF0000",color:"#FFFFFF"}}><WarningOutlined /></Button>
                        </Tooltip>
                    )
                }else{
                    if(text.hold_state == 0){
                        return(
                            <Tooltip placement="top" title="Tolong kirimkan file hardcopy nya ya, jika sudah abaikan informasi ini !">
                                <Button  className="btn-tools btn-warning" size="small" ><WarningOutlined /></Button>
                            </Tooltip>
                        )
                    }else{
                        return("-");
                    }
                }
            }
        }
    ];

    render(){
       
        return (
            <div >
                <Breadcrumb>
                    <Breadcrumb.Item>
                    <div className="TitlePage">
                        <WalletOutlined className="icon" /><DoubleRightOutlined className="iconArrow" /> <h3>Upload Nota Debet</h3>
                    </div>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row>
                <HeaderTitle onChangeDate={this.onChangeDate} onProcess={this.onProcessNota} momen={moment(this.state.Periode, 'YYYY-MM')}/>
                    <Col sm={12}  lg={12}>
                        <Card bordered={false} className="box">
                            <Row>
                                <Col sm={12}  lg={12} style={{marginBottom:20}}>
                                    <Button className="primaryButton" icon={<CloudUploadOutlined />}  onClick={this.onUploadNotaDebet}>
                                        Upload Nota Debet
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12}  lg={12}>
                                    <Spin spinning={this.state.loadingUploadNotaDebet} >
                                        <Table columns={this.columns} dataSource={this.state.TableUploadNotaDebet} />
                                    </Spin>
                                </Col>
                            </Row>
                            <Card style={{boxShadow: '#E3EAFF 1px 1px 3px 1px'}}>
                                <Row>
                                    <Col sm={2}  lg={2}>Draft</Col><Col sm={10}  lg={10}>: Hanya Dealer yang melihat data ini. </Col>
                                    <Col sm={2}  lg={2}>Waiting Validate...</Col><Col sm={10}  lg={10}>: Menunggu data divalidasi oleh link aja.</Col>
                                    <Col sm={2}  lg={2}>Waiting Approval...</Col><Col sm={10}  lg={10}>: Data sudah divalidasi, tinggal menunggu approval.</Col>
                                    <Col sm={2}  lg={2}>Waiting Payment...</Col><Col sm={10}  lg={10}>: Data sudah di approve tinggal menunggu dibayar.</Col>
                                    <Col sm={2}  lg={2}>Review AP</Col><Col sm={10}  lg={10}>: Data sudah di approve, tinggal nunggu review AP selesai.</Col>
                                    <Col sm={2}  lg={2}>Finish</Col><Col sm={10}  lg={10}>: Data transaksi sudah selesai.</Col>
                                    <Col sm={2}  lg={2}>Reject</Col><Col sm={10}  lg={10}>: Data transaksi ditolak.</Col>
                                </Row>
                            </Card>
                        </Card>
                    </Col>
                </Row>
                <Modal
                    width="900px"
                    title="Form Upload Nota Debet"
                    visible={this.state.modalFormUploadNotaDebet}
                    footer={null}
                    onCancel={this.onCancelFormUploadNotaDebet}>
                    <Spin spinning={this.state.loadingUploadNotaDebet} >
                        <Form {...layout}   ref={formUploadNotaDebet}  name="configForm" onFinish={this.onFinishFormUploadNotaDebet}>
                            <Row>
                                <Col sm={6}  lg={6}>
                         
                                    <Form.Item name="periode" 
                                        rules={[
                                            {
                                            required: true, message: 'Please input Periode Transaksi  !',
                                            },
                                        ]}
                                        label="Periode">
                                        {/* <DatePicker  picker="month" defaultValue={moment(this.state.PeriodeNota, 'YYYY-MM')}  />   */}
                                        <Input placeholder=""  readOnly={true}  />
                                    </Form.Item>

                                    <Form.Item name="ad_code" 
                                        rules={[
                                            {
                                            required: true, message: 'Please input Kode AD  !',
                                            },
                                        ]}
                                        label="Kode AD">
                                        <Input placeholder=""   readOnly/>
                                    </Form.Item>
                                    <Form.Item name="ad_name" 
                                        rules={[
                                            {
                                            required: true, message: 'Please input Nama AD  !',
                                            },
                                        ]}
                                        label="Nama AD">
                                        <Input placeholder=""  readOnly />
                                    </Form.Item>
                                    <Form.Item name="bar_attachment" 
                                        label="Doc BAR Rekon">
                                        <Upload 
                                         onRemove={this.removeBar}
                                         customRequest={this.uploadBar}
                                         fileList={this.state.fileBARRecon}
                                         // defaultFileList={this.state.fileInvoice}
                                         onChange={this.handleUploadBarChange}>
                                            <Button icon={<UploadOutlined />}>Select File BAR Recon</Button>
                                        </Upload>
                                    </Form.Item>
                                    <Form.Item name="summary_attachment" 
                                        label="DOC Summary">
                                        <Upload 
                                        onRemove={this.removeSummary}
                                        customRequest={this.uploadSummary}
                                        fileList={this.state.fileSummary}
                                        // defaultFileList={this.state.fileInvoice}
                                        onChange={this.handleUploadSummaryChange}>
                                            <Button icon={<UploadOutlined />}>Select File Summary</Button>
                                        </Upload>
                                    </Form.Item>
                                </Col>
                                <Col sm={6}  lg={6}>
                                    <Form.Item name="inv_date" 
                                        rules={[
                                            {
                                            required: true, message: 'Please input Invoice Date  !',
                                            },
                                        ]}
                                        label="Nata Debet Date">
                                        {/* <DatePicker  picker="month"  readOnly />   */}
                                        <DatePicker onChange={this.onChangeDateInv} format={"YYYY-MM-DD"} />
                                    </Form.Item>
                                   
                                    <Form.Item style={this.state.formHide==true ? {display:"none"} : {display:"block"}} name="pph_number" 
                                        // rules={[
                                        //     {
                                        //     required: true, message: 'Please input Nomor Nota Debit  !',
                                        //     },
                                        // ]}
                                        label="Nomor Nota Debet ">
                                        <Input placeholder=""  onChange={(e) => {this.onUpdateDataNota({"inv_number":e.target.value})}}   />
                                    </Form.Item>
                                    <Form.Item name="bukpot_attachment"  style={this.state.formHide==true ? {display:"none"} : {display:"block"}} 
                                        label="Doc Bukpot">
                                        <Upload 
                                        onRemove={this.removeBukpot}
                                        customRequest={this.uploadBukpot}
                                        fileList={this.state.fileBukpot}
                                        // defaultFileList={this.state.fileInvoice}
                                        onChange={this.handleUploadBukpotChange}>
                                            <Button icon={<UploadOutlined />}>Select File Bukpot</Button>
                                        </Upload>
                                    </Form.Item>
                                    <Form.Item name="bukbayar_attachment" style={this.state.formHide==true ? {display:"none"} : {display:"block"}} 
                                        label="Bukti Bayar">
                                        <Upload 
                                        onRemove={this.removeBukbayar}
                                        customRequest={this.uploadBukbayar}
                                        fileList={this.state.fileBukBayar}
                                        // defaultFileList={this.state.fileInvoice}
                                        onChange={this.handleUploadBukbayarChange}>
                                            <Button icon={<UploadOutlined />}>Select File Bukti Bayar</Button>
                                        </Upload>
                                    </Form.Item>
                                    <Form.Item name="notadebet_attachment" style={this.state.formHide==true ? {display:"none"} : {display:"block"}} 
                                        label="Doc Nota Debet">
                                        <Upload 
                                         onRemove={this.removeNotaDebit}
                                         customRequest={this.uploadNotaDebit}
                                         fileList={this.state.fileNotaDebet}
                                         // defaultFileList={this.state.fileInvoice}
                                         onChange={this.handleUploadNotaDebitChange}>
                                            <Button icon={<UploadOutlined />}>Select File Nota Debet</Button>
                                        </Upload>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Divider orientation="left">INFORMASI PENDUKUNG</Divider>
                            <Row>
                                <Col sm={12}  lg={12} >
                                    <Form.Item name="description"  {...layoutPendukung}
                                        rules={[
                                            {
                                            required: true, message: 'Please input Description  !',
                                            },
                                        ]}
                                        label="Description">
                                        <Input placeholder=""   onChange={(e) => {this.onUpdateDataNota({"description":e.target.value})}} />
                                    </Form.Item>
                                    <Form.Item name="qty_trx"  {...layoutPendukung}
                                        rules={[
                                            {
                                            required: true, message: 'Please Invoice Qty !',
                                            },
                                        ]}
                                        label="Qty">
                                        <InputNumber min={1} defaultValue={this.state.data_price.qty_trx} onChange={this.onChangeQtyNotaDebet} readOnly ={true}/>
                                    </Form.Item>
                                    <Form.Item name="price" {...layoutPendukung}
                                        rules={[
                                            {
                                            required: true, message: 'Please input Invoice Price  !',
                                            },
                                        ]}
                                        label="Price">
                                        <InputNumber style={{width:"400px"}} 
                                            defaultValue={this.state.data_price.total_amount}
                                            min={0} 
                                            formatter={value => `RP ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 
                                            parser={value => value.replace(/\RP\s?|(,*)/g, '')}   
                                            onChange={this.onChangePriceNotaDebet}
                                        />
                                    </Form.Item>
                                    <Form.Item name="total_amount" {...layoutPendukung}
                                        rules={[
                                            {
                                            required: true, message: 'Please input total amount !',
                                            },
                                        ]}
                                        label="Total Amount">
                                        <InputNumber style={{width:"400px"}} 
                                            min={0} 
                                            defaultValue={this.state.data_price.total_amount}
                                            formatter={value => `RP ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 
                                            parser={value => value.replace(/\RP\s?|(,*)/g, '')}  readOnly
                                        />
                                    </Form.Item>
                                    <Form.Item name="remarks" {...layoutPendukung}
                                        rules={[
                                            {
                                            required: true, message: 'Please input Remarks  !',
                                            },
                                        ]}
                                        label="Remarks">
                                            <TextArea placeholder="" allowClear  onChange={(e) => {this.onUpdateDataNota({"remarks":e.target.value})}} />
                                    </Form.Item>
                                    
                                </Col>
                            </Row>
                            <Divider />
                            <div style={{textAlign: 'right'}}>
                                <Button className="primaryButton" htmlType="submit" >
                                    Submit Nota Debit
                                </Button>
                            </div>
                        </Form>
                    </Spin>
                </Modal>
            </div>
        )
    }
}


export default UploadNotaDebet;
